import { Modal } from '@porterin/component-library/src/base-components';
import Image from 'next/image';

import { ResendOtpOption } from '../../../domain/entities/ResendOtpOption';
import { AuthAssets, AuthTexts } from '../../stores/AuthStore';

import ResendOptionsCmp from './ResendOptionsCmp';

export interface ResendOptionsModalProps {
  is_open: boolean;
  on_close: () => void;
  on_resend: (option: ResendOtpOption) => void;
}

const ResendOptionsModal: React.FC<ResendOptionsModalProps> = ({
  is_open,
  on_close,
  on_resend,
}) => {
  return (
    <Modal
      identifiers={{
        id: 'resend-options-modal',
        className: 'translate-y-[-2.5rem] bottom-[-2.5rem]',
      }}
      modalOptions={{
        isOpen: is_open,
        showOverlay: true,
        position: 'bottom-center',
      }}
      interactions={{
        onClose: on_close,
      }}
    >
      <div className="w-full bg-white p-[3.4rem_2rem] rounded-t-[1.6rem] md:rounded-[2rem]">
        <div
          onClick={on_close}
          className="absolute top-[-7rem] left-[50%] translate-x-[-50%] p-[1.4rem] bg-white rounded-[0.8rem]"
          id="close-resend-options-modal"
        >
          <Image
            src={AuthAssets.crossBlackIcon.src}
            alt={AuthAssets.crossBlackIcon.alt}
            height={24}
            width={24}
          />
        </div>
        <div className="text-[1.8rem] font-semibold text-[#333]">
          {AuthTexts.resendOptionsModal.title}
        </div>
        <ResendOptionsCmp on_resend={on_resend} />
      </div>
    </Modal>
  );
};

export default ResendOptionsModal;
